module.exports = __webpack_public_path__ + "static/media/logo_altendorf.49e46a68.png";